module.exports = __webpack_public_path__ + "static/img/cdi.212e1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/cdi.jpg
// module id = oCZJ
// module chunks = 0